import * as React from 'react';
import { Sizes } from '../../enums/sizes';
import { cn } from '../../utils/cn';
import { type InputProps, type InputSize, Input } from './input';

const TRAILING_PADDING: Record<InputSize, string> = {
  [Sizes.SM]: 'pr-1.5',
  [Sizes.MD]: 'pr-2',
  [Sizes.LG]: 'pr-2.5',
};

interface InputWithActionsProps extends Omit<InputProps, 'trailing'> {
  actions: React.ReactNode;
}

const InputWithActions = React.forwardRef<
  HTMLInputElement,
  InputWithActionsProps
>(({ actions, className, size = Sizes.SM, ...props }, ref) => {
  return (
    <Input
      {...props}
      ref={ref}
      size={size}
      className={cn(TRAILING_PADDING[size], className)}
      trailing={<div className='flex items-center gap-1'>{actions}</div>}
    />
  );
});

InputWithActions.displayName = 'InputWithActions';

export { InputWithActions };
